module.exports = __webpack_public_path__ + "img/pay_tab_sel.f0c7d658.png";